import { apiRequest } from "./queryClient";

export function togglePageSelection(
  selected: Set<string>,
  pageIds: string[],
): Set<string> {
  const next = new Set(selected);
  const allSelected = pageIds.length > 0 && pageIds.every((id) => next.has(id));
  pageIds.forEach((id) => (allSelected ? next.delete(id) : next.add(id)));
  return next;
}

export async function deleteContacts(ids: string[]) {
  const deleted: string[] = [];
  const failed: string[] = [];
  for (let start = 0; start < ids.length; start += 8) {
    await Promise.all(
      ids.slice(start, start + 8).map(async (id) => {
        try {
          await apiRequest("DELETE", `/api/contacts/${encodeURIComponent(id)}`);
          deleted.push(id);
        } catch {
          failed.push(id);
        }
      }),
    );
  }
  return { deleted, failed };
}

export async function loadSelectedContacts<T extends { id: string }>(
  ids: string[],
): Promise<T[]> {
  const rows: T[] = [];
  for (let start = 0; start < ids.length; start += 8) {
    rows.push(
      ...(await Promise.all(
        ids.slice(start, start + 8).map(async (id) => {
          const response = await apiRequest(
            "GET",
            `/api/contacts/${encodeURIComponent(id)}`,
          );
          return (await response.json()) as T;
        }),
      )),
    );
  }
  return rows;
}

export async function loadFilteredContacts<T>(
  search: string,
  category: string,
): Promise<T[]> {
  const rows: T[] = [];
  for (let page = 1; ; page++) {
    const params = new URLSearchParams({ page: String(page), limit: "200" });
    if (search) params.set("search", search);
    if (category !== "All Categories") params.set("category", category);
    const response = await apiRequest("GET", `/api/contacts?${params}`);
    const data = await response.json();
    rows.push(...data.contacts);
    if (!data.pagination.hasMore) return rows;
  }
}
